import { SearchProps } from '../../components/SearchForm';
import useLeadSearchSuggestions from './useLeadSearchSuggestions';

// The header search config shared by the form-fills list and the form-fill
// detail page, so both surfaces look up form fills the same way. The detail page
// adds `searchTo` on top to turn it into a jump-to control.
const leadSearchProps: Pick<SearchProps, 'searchLabel' | 'useSearchSuggestions'> = {
    searchLabel: 'Search form fill',
    useSearchSuggestions: useLeadSearchSuggestions
};

export default leadSearchProps;
